/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAExportIcon32Regular = forwardRef('ArrowUiShareAExportIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8.5 5A3.5 3.5 0 0 0 5 8.5v15A3.5 3.5 0 0 0 8.5 27h15a3.5 3.5 0 0 0 3.5-3.5V21a1 1 0 1 1 2 0v2.5a5.5 5.5 0 0 1-5.5 5.5h-15A5.5 5.5 0 0 1 3 23.5v-15A5.5 5.5 0 0 1 8.5 3H15a1 1 0 1 1 0 2H8.5Z" }),
        React.createElement("path", { d: "M21 11a6 6 0 0 0-6 6v1a1 1 0 1 1-2 0v-1a8 8 0 0 1 8-8h7.586l-4.293-4.293a1 1 0 0 1 1.414-1.414l4.586 4.586a3 3 0 0 1 0 4.242l-4.586 4.586a1 1 0 0 1-1.414-1.414L28.586 11H21Z" })));
});
